import { render, staticRenderFns } from "./_NotesAndEncounters.vue?vue&type=template&id=98f01934"
import script from "./_NotesAndEncounters.vue?vue&type=script&lang=ts"
export * from "./_NotesAndEncounters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports